import React from 'react'
import { Table, Badge, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash, IconCategory } from '@tabler/icons-react'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          leftSection={<IconCategory stroke={1.5} size={14} />}
          onClick={() => handleAction('editCategory')}
          fw='600'
          fz={11}
        >
          Edit Category
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableBrands = ({ label, data, actionMethod }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.name}</Table.Td>
        <Table.Td>{val.country ? val.country : '-'}</Table.Td>
        <Table.Td><Badge variant="light" w={50} color={val.principal_brand ? 'teal' : 'red'} tt='capitalize' fw='500'>{val.principal_brand ? 'Yes' : 'No'}</Badge></Table.Td>
        <Table.Td>{
          val.open_distributor_country.length !== 0
            ? val.open_distributor_country.map(e => e.name).join(', ')
            : '-'
          }
        </Table.Td>
        <Table.Td><Badge variant="light" w={50} color={val.is_import ? 'teal' : 'red'} tt='capitalize' fw='500'>{val.is_import ? 'Yes' : 'No'}</Badge></Table.Td>
        <Table.Td><Badge variant="light" w={50} color={val.is_partnered ? 'teal' : 'red'} tt='capitalize' fw='500'>{val.is_partnered ? 'Yes' : 'No'}</Badge></Table.Td>
        <Table.Td><Badge variant="light" w={50} color={val.featured ? 'teal' : 'red'} tt='capitalize' fw='500'>{val.featured ? 'Yes' : 'No'}</Badge></Table.Td>
        <Table.Td>{val.categories !== null ? val.categories.name : '-'}</Table.Td>
        <Table.Td><Badge variant="light" w={70} color={val.status ? 'teal' : 'red'} tt='capitalize' fw='500'>{val.status ? 'Active' : 'Inactive'}</Badge></Table.Td>
        {/* <Table.Td>{val.website ? val.website : '-'}</Table.Td> */}
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })
  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableBrands